import { ENDPOINTS } from 'config/endpoints';
import { useMutation } from '@tanstack/react-query';
import client from 'utils/clients/client';
import { Request } from 'crono-fe-common/types/request';
import { Response } from 'crono-fe-common/types/response';
import CronoError from 'crono-fe-common/types/error';
import IntegrationType from 'crono-fe-common/types/enums/integrationType';
import { getLabelForIntegrationType } from 'crono-fe-common/utils/crm-utils';

export type PipedriveOauthCode = {
  code: string;
};

const integrationLabel = getLabelForIntegrationType(IntegrationType.PIPEDRIVE);

const pipedriveAuthCallback = (data: PipedriveOauthCode) => {
  const request: Request = {
    url: ENDPOINTS.pipedrive.authCallback,
    config: {
      method: 'post',
      data: data,
    },
  };

  return client(request);
};

const usePipedriveAuthCallback = () =>
  useMutation<Response<null>, CronoError, PipedriveOauthCode>(
    pipedriveAuthCallback,
    {
      meta: {
        successMessage: `Successfully logged into ${integrationLabel}`,
        errorMessage: 'Error while connecting with the CRM',
      },
    },
  );

export default usePipedriveAuthCallback;
